import { useCallback, useState } from 'react';

import PlayerImagePlaceholder from '@/assets/images/playerImagePlaceholder';
import { Image } from '@/components/lib/components';
import { Box } from '@/components/lib/components/Box';
import { ds } from '@/components/lib/design.system';
import { AppColors } from '@/components/lib/theme';
import { isPlayerImgPlaceholder } from '@/utils/player';

export const EventCardPlayerIcon = ({
    uri,
    size = { width: 20, height: 20 },
    placeholderSize = { width: 20, height: 18 },
    backgroundColor = ds.colorToken.background.neutral.subtle,
    borderRadius = 'r6',
}: {
    uri?: string;
    size?: { width: number; height: number };
    placeholderSize?: { width: number; height: number };
    backgroundColor?: AppColors;
    borderRadius?: 'r6' | 'r8';
}) => {
    const [hasErrorLoadingImage, setHasErrorLoadingImage] = useState(false);
    const showPlaceholder = isPlayerImgPlaceholder(uri) || hasErrorLoadingImage;

    const onError = useCallback(() => setHasErrorLoadingImage(true), []);

    return (
        <Box
            width={size.width}
            height={size.height}
            borderRadius={borderRadius}
            overflow={'hidden'}
            backgroundColor={backgroundColor}
            justifyContent={'flex-end'}
            alignItems={'center'}
        >
            {showPlaceholder ? (
                <PlayerImagePlaceholder width={placeholderSize.width} height={placeholderSize.height} />
            ) : (
                <Image
                    source={{ uri }}
                    style={{ width: size.width, height: size.height }}
                    resizeMode="cover"
                    onError={onError}
                />
            )}
        </Box>
    );
};
